import { atom, useAtom } from 'jotai';
export const dchDebitCardNameAtom = atom({});
export const useDCHDebitCardNameAtom = () => {
    return useAtom(dchDebitCardNameAtom);
};
